"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationDesignerRecruit',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        invite: '邀约',
        join: '入职',
        reject: '拒绝'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationDesignerRecruitListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('设计师姓名', '登记候选人').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationDesignerRecruitSaveApi)({
          designerName: value || 'E2E设计师',
          contactPhone: '13900002222',
          specialty: '全案设计',
          yearsExperience: 5
        }).then(function () {
          _this2.$message.success('已登记');
          _this2.reload();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      (0, _decoration.decorationDesignerRecruitActionApi)(row.recruit.id, {
        action: action
      }).then(function () {
        _this3.$message.success('已更新');
        _this3.reload();
      });
    }
  }
};